import { jsx, jsxs } from "react/jsx-runtime";
import { CheckCircle2 } from "@tamagui/lucide-icons";
import { Toast } from "@tamagui/toast";
import React from "react";
import { Button, XStack, YStack } from "tamagui";
const ToastDuplicateDemo = () => {
  const [savedCount, setSavedCount] = React.useState(0);
  return /* @__PURE__ */ jsxs(YStack, { alignItems: "center", children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        onPress: () => {
          setSavedCount((old) => old + 1);
        },
        children: "Show toast"
      }
    ),
    [...Array(savedCount)].map((_, index) => /* @__PURE__ */ jsx(
      Toast,
      {
        viewportName: "viewport-multiple",
        duration: 4e3,
        enterStyle: { opacity: 0, scale: 0.5, y: -25 },
        exitStyle: { opacity: 0, scale: 1, y: -20 },
        y: 0,
        opacity: 1,
        scale: 1,
        animation: "100ms",
        children: /* @__PURE__ */ jsxs(XStack, { space: true, alignItems: "center", children: [
          /* @__PURE__ */ jsx(YStack, { children: /* @__PURE__ */ jsx(CheckCircle2, {}) }),
          /* @__PURE__ */ jsxs(YStack, { children: [
            /* @__PURE__ */ jsx(Toast.Title, { children: "Successfully saved!" }),
            /* @__PURE__ */ jsx(Toast.Description, { children: "Don't worry... We've got your data." })
          ] })
        ] })
      },
      index
    ))
  ] });
};
export {
  ToastDuplicateDemo
};
//# sourceMappingURL=ToastDuplicateDemo.js.map
